export default __webpack_public_path__ + "static/media/medical_7.c88a9d24.jpg";